export default "__VITE_ASSET__2seC8DgtsO0ucggS_u9_sQ__";